export default {
      id: "open-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#open-usage",
      toString: function () {
        return this.url;
      }
    }